import { Toast } from '@skbkontur/react-ui';
import { checkValueEmpty, convertDatePickerToISO, isCloud, normalizeObject, } from '@skbkontur/staff-common';
const defaultBankAccount = {
    name: '',
    bik: '',
    paymentAccount: '',
};
const defaultOrganization = {
    name: '',
    bik: '',
    inn: '',
    paymentAccount: '',
    account: '',
    recipientAccount: '',
    kbk: '',
};
const defaultReferenceItem = {
    code: '',
    name: '',
};
const defaultEmployee = {
    firstName: '',
    lastName: '',
    middleName: '',
    birthday: '',
    snils: '',
    inn: '',
    email: '',
    residentStatus: defaultReferenceItem,
    citizenship: defaultReferenceItem,
    bankAccount: defaultBankAccount,
    mirCard: '',
    organization: defaultOrganization,
    identityDocuments: [],
    activeIdentityDocumentId: null,
    identityDocumentEditStatus: 'closed',
    phone: '',
    matchFields: null,
    formStatus: 'edit',
    tabStatus: 'main',
    showSfrField: false,
    matchValidationLevel: 'error',
};
export const toEditState = (employee, references) => {
    if (!employee) {
        return { ...defaultEmployee };
    }
    const { profile, requisites } = employee;
    const { name, sex, birthday, snils, inn, citizenship, email, registrationAddress, homeAddress } = profile;
    return {
        ...defaultEmployee,
        firstName: name.firstName || defaultEmployee.firstName,
        lastName: name.lastName || defaultEmployee.lastName,
        middleName: name.middleName || defaultEmployee.middleName,
        sex: sex || defaultEmployee.sex,
        birthday: birthday || defaultEmployee.birthday,
        snils: snils || defaultEmployee.snils,
        inn: inn || defaultEmployee.inn,
        email: email || defaultEmployee.email,
        residentStatus: findReferenceNameByCode(references, 'residentStatuses', requisites?.taxes?.residentStatus) ||
            defaultEmployee.residentStatus,
        citizenship: findReferenceNameByCode(references, 'countries', citizenship?.countryCode) || defaultEmployee.citizenship,
        bankAccount: requisites?.socialBenefits?.paymentMethods?.bankAccount || defaultEmployee.bankAccount,
        mirCard: requisites?.socialBenefits?.paymentMethods?.mirCard || defaultEmployee.mirCard,
        organization: requisites?.socialBenefits?.paymentMethods?.organization || defaultEmployee.organization,
        registrationAddress,
        homeAddress,
        phone: profile.phone || defaultEmployee.phone,
        matchValidationLevel: employee === null ? 'error' : 'warning',
    };
};
export const findReferenceNameByCode = (references, referenceType, code) => {
    return code ? references[referenceType].find((item) => item.code === code) : undefined;
};
export const getChangedFields = (operations) => {
    return operations.reduce((r, { op, path }) => ({ ...r, [path]: op }), {
        count: operations.length,
    });
};
export function toEmployee({ lastName, firstName, middleName, sex, birthday, email, snils, inn, registrationAddress, homeAddress, residentStatus, citizenship, bankAccount, mirCard, organization, phone, }) {
    return {
        profile: {
            name: {
                lastName: lastName ?? '',
                firstName: firstName,
                middleName: middleName,
            },
            birthday: convertDatePickerToISO(birthday),
            registrationAddress: checkValueEmpty(registrationAddress) ? undefined : registrationAddress,
            homeAddress: checkValueEmpty(homeAddress) ? undefined : homeAddress,
            citizenship: citizenship ? { countryCode: citizenship.code } : undefined,
            sex,
            snils,
            inn,
            email,
            phone,
        },
        requisites: {
            ...(residentStatus?.code ? { taxes: { residentStatus: residentStatus.code } } : undefined),
            socialBenefits: {
                paymentMethods: {
                    bankAccount,
                    mirCard,
                    organization,
                },
            },
        },
        id: '',
    };
}
export const toPatchEmployee = (employee, fields) => {
    return normalizeObject({
        profile: {
            name: {
                lastName: employee.profile?.name.lastName || '',
                firstName: employee.profile?.name.firstName,
                middleName: employee.profile?.name.middleName,
            },
            birthday: employee.profile?.birthday,
            sex: fields.sex ? employee.profile?.sex : undefined,
            inn: fields.inn ? employee.profile?.inn : undefined,
            snils: fields.snils ? employee.profile?.snils : undefined,
            citizenship: fields.citizenship ? employee.profile?.citizenship : undefined,
            registrationAddress: fields.registrationAddress ? employee.profile?.registrationAddress : undefined,
            homeAddress: fields.homeAddress ? employee.profile?.homeAddress : undefined,
            email: fields.email ? employee.profile?.email : undefined,
            phone: fields.phone ? employee.profile?.phone : undefined,
        },
        requisites: {
            taxes: {
                residentStatus: fields.residentStatus ? employee.requisites?.taxes?.residentStatus : undefined,
            },
            socialBenefits: {
                paymentMethods: {
                    bankAccount: fields.bankAccount
                        ? employee.requisites?.socialBenefits?.paymentMethods?.bankAccount
                        : undefined,
                    mirCard: fields.mirCard ? employee.requisites?.socialBenefits?.paymentMethods?.mirCard : undefined,
                    organization: fields.organization
                        ? employee.requisites?.socialBenefits?.paymentMethods?.organization
                        : undefined,
                },
            },
        },
    });
};
export const handleDocumentSaveError = () => {
    Toast.push('Не удалось сохранить документ');
};
export const logRequestError = (error, payload) => {
    // TODO request errors logger
    // eslint-disable-next-line no-console
    isCloud() && console.error({ error, payload });
};
export const convertEmployeesToMatchFields = (state, candidates) => {
    if (candidates.length === 0) {
        return null;
    }
    const getProperty = (acc, value, key) => {
        if (state[key] === value) {
            return value || undefined;
        }
        return acc[key];
    };
    return candidates.reduce((acc, cur) => {
        return {
            firstName: getProperty(acc, cur.profile.name.firstName, 'firstName'),
            lastName: getProperty(acc, cur.profile.name.lastName, 'lastName'),
            middleName: getProperty(acc, cur.profile.name.middleName, 'middleName'),
            inn: getProperty(acc, cur.profile.inn, 'inn'),
            snils: getProperty(acc, cur.profile.snils, 'snils'),
            phone: getProperty(acc, cur.profile.phone, 'phone'),
            email: getProperty(acc, cur.profile.email, 'email'),
            birthday: getProperty(acc, cur.profile.birthday, 'birthday'),
        };
    }, {});
};
export const toMatchEmployeeRequest = (state, employee) => {
    return {
        profile: {
            name: {
                firstName: state.firstName || employee?.profile.name.firstName || undefined,
                lastName: state.lastName || employee?.profile.name.lastName || '',
                middleName: state.middleName || employee?.profile.name.middleName || undefined,
            },
            inn: state.inn || employee?.profile.inn || undefined,
            snils: state.snils || employee?.profile.snils || undefined,
            phone: state.phone || employee?.profile.phone || undefined,
            email: state.email || employee?.profile.email || undefined,
            birthday: state.birthday || employee?.profile.birthday || undefined,
        },
        resolveCandidates: true,
    };
};
export const getBankPaymentRequisites = (state) => {
    return {
        name: state.bankAccount?.name || '',
        bik: state.bankAccount?.bik || '',
        paymentAccount: state.bankAccount?.paymentAccount || '',
    };
};
export const getOrganizationPaymentRequisites = (state) => {
    return {
        bik: state.organization?.bik || '',
        name: state.organization?.name || '',
        paymentAccount: state.organization?.paymentAccount || '',
        account: state.organization?.account || '',
        recipientAccount: state.organization?.recipientAccount || '',
        kbk: state.organization?.kbk || '',
        registrationNumber: state.organization?.registrationNumber || '',
        inn: state.organization?.inn || '',
        kpp: state.organization?.kpp || '',
        registrationNumberSfr: state.organization?.registrationNumberSfr || '',
    };
};
